module.exports = __webpack_public_path__ + "img/renbao.620adfa6.png";